import { AuthService, StorageService } from '../services';
import { authType, commonAction } from './type';

// Actions - Login

export const login = (_authUser) => async (dispatch) => {
  try {
    StorageService.setObject('authUser', _authUser);
    dispatch({
      type: authType.SUCCESS,
      payload: {
        user: _authUser,
      },
    });

    // return Promise.resolve(_loginResp);
  } catch (error) {
    dispatch({
      type: authType.FAILURE,
    });
    return Promise.reject(error);
  }
};

export const logout = () => (dispatch) => {
  try {
    StorageService.purgeData('authUser');
    dispatch({
      type: authType.LOGOUT,
    });
  } catch {
    dispatch({
      type: authType.FAILURE,
    });
  }
};

export const updateAuthUser = (_formData) => async (dispatch) => {
  try {
    // let _authUser = StorageService.getObject("authUser");
    // _authUser["profilePictureUrl"] = _formData;

    StorageService.setObject('authUser', _formData);

    dispatch({
      type: authType.SUCCESS,
      payload: { user: _formData },
    });
  } catch (error) {
    dispatch({
      type: authType.FAILURE,
    });
    return Promise.reject(error);
  }
};

export const verifyTwoFA = (verifyTwoFAData) => async (dispatch) => {
  try {
    const response = await AuthService.verifyTwoFA(verifyTwoFAData);
    if (response.status === 'failure') {
      dispatch({
        type: commonAction.FAILURE,
      });
    }

    dispatch({
      type: commonAction.SUCCESS,
      payload: '',
    });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({
      type: commonAction.FAILURE,
    });
    return Promise.reject(error);
  }
};
